module.exports = __webpack_public_path__ + "static/media/spotify.8ad1b4f9.jpg";